<script setup lang="ts">
const model = defineModel<string>()

const onInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  model.value = target.value
}
</script>

<template>
  <input :class="$style.root" type="search" placeholder="Search" :value="model" @input="onInput" />
</template>

<style lang="scss" module>
.root {
  width: 100%;
  min-width: 0;
  font-size: 15px;
  line-height: 32px;
  height: 32px;
  padding-left: 34px;
  padding-right: 10px;
  border-radius: 4px;
  background-color: #1f1f22;
  color: white;
  background-repeat: no-repeat;
  background-position: 10px center;
  background-image: url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.25 12.2501L9.71658 9.7167M9.71658 9.7167C10.1499 9.28335 10.4937 8.76889 10.7282 8.20269C10.9627 7.63649 11.0835 7.02964 11.0835 6.41679C11.0835 5.80394 10.9627 5.19709 10.7282 4.63088C10.4937 4.06468 10.1499 3.55022 9.71658 3.11687C9.28323 2.68352 8.76877 2.33977 8.20257 2.10524C7.63637 1.87071 7.02952 1.75 6.41666 1.75C5.80381 1.75 5.19696 1.87071 4.63076 2.10524C4.06456 2.33977 3.5501 2.68352 3.11675 3.11687C2.24156 3.99206 1.74988 5.17908 1.74988 6.41679C1.74988 7.6545 2.24156 8.84151 3.11675 9.7167C3.99194 10.5919 5.17896 11.0836 6.41666 11.0836C7.65437 11.0836 8.84139 10.5919 9.71658 9.7167Z' stroke='%239596A5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  border: none;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: #9596a5;
  }
}
</style>
